<template minapp="mpx" xlang="wxml">
  <view class="es-train-information">
    <view class="es-train-information-container">
      <view wx:if="{{isRecommendTicket}}" class="recommend" >
        <view class="recommend-tips" style="{{keyTips?'justify-content:space-between':'justify-content:flex-end'}}">
          <view class="left" wx:if="{{keyTips}}">{{keyTips}}</view>
          <view class="right">
            <view class="recommend-checkin">{{defaultCheckIn}}</view>
          </view>
        </view>
        <more-less-guide guide="{{recommendGuide}}" orderDetail="{{true}}"/>
        <view wx:if="{{isOnBoard}}" class="warning" bindtap="goWarning">利用”买短乘长“恶意逃票属违法行为，情节严重的将被追究刑事责任</view>
      </view>
      <view wx:elif="{{checkIn}}" class="train-gate-info">
        <view class="train-gate-info-left">
          <image class="train-gate-info-left-icon" src="https://ut-static.udache.com/webx/sfc/AukeLGBbJQjkJEsPtVbHT.png" />
          <view class="train-gate-info-left-checkin">{{defaultCheckIn}}</view>
        </view>
        <view wx:if="{{isChange}}" class="change">已改签</view>
      </view>
      <view class="es-train-information-container-top" wx:style="display: flex">
        <view wx:if="{{cardIndex}}" class="transfer-segment-container">
          <text class="word">第</text>
          <text class="word number">{{cardIndex}}</text>
          <text class="word">程</text>
        </view>
        <view class="info" wx:class="{{{'no-detail': noDetail, 'transfer': cardIndex, 'lessbottom': hasSlot() }}}" wx:style="{{showDate && !hasSlot() ? {paddingTop: '22px'} : {}}}">
          <slot name="headerSlot"></slot>
          <image class="train-image" src="https://ut-static.udache.com/webx/sfc/ZnWx-lzsNC0YijiX26bVy.png" wx:class="{{cardIndex && 'transform'}}" />
          <view wx:if="{{dayDifference > 0}}" class="day-difference">{{ `+${dayDifference}天` }}</view>
          <view class="es-train-information-item">
            <view class="es-train-info-date" wx:if="{{showDate}}" wx:style="{{showDate ? {marginBottom: '5px', marginTop: '3px'} : {}}}">{{ startTime.date }} {{ startTime.week }}</view>
            <view class="es-train-info-time" wx:style="{{showDate || cardIndex ? {} : {marginTop: '11px'}}}">{{ startTime.time }}</view>
            <view class="es-train-station-name">
              {{ fromStationName }}
              <view class="station-tag">{{isStartStation ? '始' : '过'}}</view>
            </view>
          </view>
          <view class="es-train-information-item" wx:style="{{{paddingTop: '2px', alignItems: 'center', justifyContent: 'center'}}}">
            <view wx:class="{{ !cardIndex ? 'es-train-code' : 'es-train-code-date'}}"
              >{{ trainCode }}<text wx:if="{{cardIndex}}" class="travel-time">{{ travelTime }}</text>
            </view>
            <view class="es-train-info-container" wx:style="marginTop: 4px">
              <view class="line"></view>
              <view class="es-train-info" bindtap="onClick">时刻表</view>
              <view class="line"></view>
            </view>
             <view wx:if="{{!cardIndex}}"class="travel-time-date" >{{ travelTime }}</view>
          </view>
          <view class="es-train-information-item" wx:style="text-align: right">
            <view class="es-train-info-date" wx:if="{{showDate}}" wx:style="{{showDate ? {marginBottom: '5px', marginTop: '3px'} : {}}}">{{ endTime.date }} {{ endTime.week }}</view>
            <view class="es-train-info-time" wx:style="{{showDate || cardIndex ? {} : {marginTop: '11px'}}}">{{ endTime.time }}</view>
            <view class="es-train-station-name" wx:style="justify-content: flex-end">
              <view class="station-tag">{{isEndStation ? '终' : '过'}}</view>
              {{ toStationName }}
            </view>
          </view>
        </view>
      </view>
    </view>
    <slot name="footerSlot"></slot>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { getFullDate, formatDate, getWeek, parseDate } from '@/utils/baseDate'
  import store from '@/store'
  import { getStorage, setStorage } from '@/utils/storage'
  import { STORAGE_TRAIN_INFO } from '@/utils/train-storage'
  import { generateDurationFunc } from '@/utils/timeDeal'
  import { formatRecommendTicketGuide } from '@/utils/recommend'
  import { goTo } from '@didi/webx-js'
  import { OrderStatus } from '@/common/enum'


  /**
   * @props.trainInfo {Object} 当前所选坐席
   * @props.trainInfo.start_station_name {String}
   * @props.trainInfo.end_station_name {String}
   * @props.trainInfo.from_station_name {String}
   * @props.trainInfo.to_station_name {String}
   * @props.trainInfo.train_code {String}
   * @props.trainInfo.start_time {String}
   * @props.trainInfo.arrive_time {String}
   */
  createComponent({
    props: {
      trainInfo: Object,
      showDate: false,
      checkIn: {
        type: String,
        value: '',
      },
      noDetail: {
        type: Boolean,
        value: false,
      },
      // 中转联程
      cardIndex: {
        type: Number,
        value: 0,
      },
      showRecommend: {
        type: Boolean,
        value: false
      }
    },
    data: {},
    methods: {
      onClick() {
        this.triggerEvent('click', this.trainInfoMap)
      },
      getTimeFromDate(date) {
        if (date != null && date != '') {
          var time = parseDate(date)
          return formatDate(time, 'hh:mm')
        } else {
          return '--'
        }
      },
      hasSlot() {
        return !!this.$slots.footerSlot
      },
      goWarning() {
        goTo({url: 'https://v.didi.cn/dW8eLQl'})
      }
    },
    computed: {
      ...store.mapState({
        state: 'order.base_info.status', // 订单状态
        statusName: 'order.base_info.status_name'
      }),
      isRecommendTicket() {
        return this.showRecommend && this.trainInfo?.expect_ticket?.expect_from_station && this.trainInfo?.expect_ticket?.type && this.trainInfo?.is_change !== 1 && this.state === OrderStatus.ISSUED && this.statusName === '已出票'
      },
      recommendGuide() {
        return formatRecommendTicketGuide({...this.trainInfo, recommend_ticket: this.trainInfo.expect_ticket})
      },
      trainInfoMap() {
        let info
        if (this.trainInfo?.start_time) {
          info = this.trainInfo || {}
        } else {
          const { trainInfo } = getStorage(STORAGE_TRAIN_INFO) || {}
          info = trainInfo
        }
        return info
      },
      startTime() {
        const trainInfo = this.trainInfoMap
        return {
          date: formatDate(trainInfo?.start_time, 'MM月dd日'),
          week: getWeek(parseDate(trainInfo?.start_time)),
          time: this.getTimeFromDate(trainInfo?.start_time)
        }
      },
      endTime() {
        const trainInfo = this.trainInfoMap
        return {
          date: formatDate(trainInfo?.arrive_time, 'MM月dd日'),
          week: getWeek(parseDate(trainInfo?.arrive_time)),
          time: this.getTimeFromDate(trainInfo?.arrive_time)
        }
      },
      travelTime() {
        const trainInfo = this.trainInfoMap
        if (trainInfo?.travel_time_name) {
          const str = trainInfo?.travel_time_name
          return str.substring(2, str.length)
        } else {
          return ''
        }
      },
      fromStationName() {
        const trainInfo = this.trainInfoMap
        return trainInfo?.from_station_name
      },
      toStationName() {
        const trainInfo = this.trainInfoMap
        return trainInfo?.to_station_name
      },
      isStartStation() {
        const trainInfo = this.trainInfoMap
        return trainInfo?.is_start_station
      },
      isEndStation() {
        const trainInfo = this.trainInfoMap
        return trainInfo?.is_end_station
      },
      trainCode() {
        const trainInfo = this.trainInfoMap
        return trainInfo?.train_code
      },
      showSilent() {
        return this.trainInfoMap?.special_flag > 0
      },
      dayDifference() {
        return +this.trainInfoMap?.day_difference
      },
      isChange() {
        return this.trainInfoMap.is_change
      },
      defaultCheckIn() {
        return this.checkIn === 'default' ?  '在火车站查看检票口' : '检票口'+this.checkIn
      },
      //关键提示
      keyTips() {
        return this.trainInfoMap?.expect_ticket?.tips
      },
      //是否是上车补票
      isOnBoard() {
        return this.trainInfoMap?.expect_ticket?.type === 3
      },
    }
  })
</script>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  .es-train-information
    // padding 0 10px 14px
    &-container
      background #EAF3FF
      display flex
      border-radius 10px
      position relative
      flex-direction column
      background #338FFF
      .recommend
        padding 16px 16px 10px 16px
        color #FFFFFF
        .recommend-tips
          display flex
          align-items center
          font-weight 800
          margin-bottom 22px
          .left
            min-width 174px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            margin-right 8px
            font-weight 800
            font-size 16px
            flex 1
          .right
            align-self flex-end
            max-width 126px
            font-size 14px
        .recommend-checkin
            text-align right
            font-weight 800
            font-size 14px
            display -webkit-box
            -webkit-box-orient vertical
            overflow hidden
            -webkit-line-clamp 2
        .warning
          font-size 10px
          color #ADD2FF
          margin-top 8px
          margin-bottom -2px
          position relative
          &::after
            position absolute
            content ''
            width 4px
            height 4px
            border-top 1px solid
            border-right 1px solid
            position absolute
            top 5px
            right 2px
            transform rotate(45deg)
      .train-gate-info
        display flex
        justify-content space-between
        padding 10px 0 10px 16px
        border-radius 10px 10px 0 0
        font-family PingFangSC-Medium
        font-size 14px
        line-height 14px
        color #fff
        z-index 1
        position relative
        &-left
          display flex
          &-icon
            height 14px
            width 14px
            margin-right 5px
          &-name
            font-family PingFangSC-Regular
            margin-right 9px
        .change
          position absolute
          top 0
          right 0
          width 100px
          height 45px
          display flex
          font-family PingFangSC-Medium
          font-weight 500
          font-size 14px
          flex-direction row-reverse
          padding 10px 16px 0 0
          box-sizing border-box
          background-size contain
          background-image url('https://ut-static.udache.com/webx/sfc/VdAlNyO5aJfgFXS0oRefC.png')
      .day-difference
        position absolute
        right 10px
        top 10px
        font-size 13px
        color #333333
        font-family PingFangSC-Semibold
      .info
        display flex
        flex 1
        justify-content space-between
        padding 22px 16px 25px 16px
        border-radius 10px 10px 0 0
        position relative
        background #EAF3FF
        z-index 2
        &.no-detail
          border-radius 10px
        .train-image
          position absolute
          width 156.5px
          height 55px
          top 32px
          left 50%
          transform  translateX(-50%)
          &.transform
            transform translate(-50%, -10px)
        &.transfer
          border-radius 0 10px 10px 0
        &.lessbottom
          padding-bottom 20px
          padding-top 14px
    .es-train-information-item
      display flex
      flex-direction column
      // justify-content space-between
      min-width 70px
      position relative
      .es-train-info-date, .es-train-info-travel-time
        font-size 13px
        color $train-color-666
      .es-train-info-time
        font-size 32px
        color $train-color-333
        font-weight 500
        font-family Barlow Semi Condensed
        line-height 32px
      .es-train-code
        line-height 20px
        font-size 15px
        color #333
        display flex
        align-items center
        font-family Barlow Semi Condensed
        font-weight 500
        margin-top 5px
      .es-train-code-date
        color #2F497D
        font-size 12px
        font-family PingFangSC-Regular
        line-height 12px
      .travel-time
        margin-left 5px
      .travel-time-date
        font-size 13px
        color #333333
        margin-top 4px
      .es-train-station-name
        font-size 13px
        color #333333
        display flex
        align-items center
        line-height 13px
        margin-top 6px
        .station-tag
          border-radius 3px
          text-align center
          border 0.5px solid #95BCD6
          width 11px
          height 11px
          text-align center
          line-height 12px
          font-size 9px
          color #3B6E8F
          margin 0 2px
      .es-train-info-container
        display flex
        align-items center
        margin-top 10px
      .line
        width 18px
        height 1px
        background #95BCD6
      .es-train-info
        position relative
        width 50px
        height 18px
        color #3B6E8F
        font-size 10px
        border-radius 8px
        text-align center
        line-height 18px
        &:after
          position absolute
          content ''
          width 200%
          height 200%
          box-sizing border-box
          border 1px solid #95BCD6
          transform-origin 0 0
          transform scale(0.5)
          border-radius 12px
          top 0
          left 0
      .es-train-divider
        border-bottom 1px solid #CAD0DA
        width 100%
  .es-train-information-container
    display flex
    flex-direction column
  .es-train-information-container-top
    display flex
    .transfer-segment-container
      display flex
      flex-direction column
      justify-content  center
      font-family PingFang SC
      padding 0 12px
      font-size 12px
      font-weight 400
      text-align center
      color #2F497D
      background #D2E6FF
      border-radius 10px 0 0 10px
      .word
        height 20px
      .number
        margin -5px 0
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'more-less-guide': '@/components/recommend-ticket/more-less-guide',
    }
  }
</script>